import type { SPXAPI } from '../interfaces';
import { BASEURL, ENDPOINTS } from '../endpoints';

export interface ApplyRulesRequest {
    file_ids: string[];
    sender: string;
    recipients: string[];
    groups: string[];
}

export interface ApplyRulesResult {
    file_id: string;
    action: 'block' | 'policy';
    rule: string;
    policy_id?: string;
    recipients: string[];
    groups: string[];
    sender: string;
    classification: string;
}

export type ApplyRulesResponse = ApplyRulesResult[];

const applyRules = async (
    API: SPXAPI,
    request: ApplyRulesRequest,
): Promise<ApplyRulesResponse> => {
    const response = await API.post(BASEURL.backend(), ENDPOINTS.applyRules(), {
        body: request,
    });
    return response;
};

export default applyRules;
